import { useEffect, useMemo, useState } from 'react';
import styles from './detail.module.scss';
import { MyPublicationDetailProps } from '../../../../interfaces/pages';
import ButtonShared from '../../../../components/Button/Button';
import PublicationDetailRefactored from '../../../../components/PublicationDetail/PublicationDetailRefactored';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../../helpers/hooks';
import ProfileCard from '../../../../components/ProfileCard/ProfileCard';
import { myPubBrandDetailBreadCrumb } from '../../../../constants/breadCrumbs';
import { useWindowSize } from "use-hooks";
import { capitalize } from '../../../../helpers/app';
import { caracteristics, conforts } from '../../../../constants/images';

const Detail = ({
    user,
    getPublication,
    getArticlesFromPublication,
    publication,
    cleanAllPublication
}: MyPublicationDetailProps) => {
    const params = useParams();
    const toast = useToast();
    const navigate = useNavigate();
    const windowSize = useWindowSize();
    const [publicationAux, setPublicationAux] = useState<any>({});
    const [selectedDealership, setSelectedDealership] = useState('');
    const [selectedVersion, setSelectedVersion] = useState('');

    const handlePressManagement = () => {
        cleanAllPublication();
        navigate(`/profile/my_publications_brand/${publication?.data?._id}/management`);
    }

    const handlePressEdit = () => {
        navigate(`/profile/my_publications_brand/${publication?.data?._id}/edit`);
    }

    const publicationNormalized = useMemo(() => {
        const vehicles = publication?.data?.vehicles || [];

        return {
            id: publication.data._id,
            title: publication.data.title,
            brand: publication.data.brand_data?.brand_name,
            brand_photo: publication.data.brand_data?.brand_photo,
            price: publication.data.price,
            year: publication.data.year,
            region: "-",
            status: publication.data.status_brief?.name,
            paused: publication.data.paused,
            pictures: publication.data.pictures,
            versions: vehicles
                .slice()
                .sort((a: any, b: any) => a.price - b.price)
                .map((v: any) => ({
                    id: v._id,
                    version: v.version,
                    model: v.model,
                    price: v.price,
                    year: v.year,
                    type: v.type,
                    fuel: v.fuel,
                    doors: v.doors,
                    transmission: v.transmission,
                    images: Array.isArray(v.images) ? v.images.map((img: any, idx: number) => ({
                        ...img,
                        previewURL: img?.path || img?.url || img?.uri || '',
                        index: idx,
                        upload: 'success',
                        protected: idx < 5
                    })) : [],
                    additional_characters: v.additional_characters || [],
                })),
        };
    }, [publication]);

    useEffect(() => {
        if (publication?.fetching === 'failure' || publication?.articles?.fetching === 'failure') {
            if (publication?.error === 'ID_INVALID_FORMAT' || publication?.articles?.error === 'ID_INVALID_FORMAT') {
                return navigate('/profile/my_publications_brand');
            }
        }

        if (publication?.fetching === 'success' && Array.isArray(publication?.data) && publication?.data.length > 0) {
            setPublicationAux(publication.data[0]);
        }
    }, [publication?.fetching, publication?.articles?.fetching]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (params.id) {
            getPublication(params.id);
        } else {
            navigate('/');
        }
    }, [params]);

    return (
        <ProfileCard className={styles.myPublicationDetailContainer} breadCrumbs={myPubBrandDetailBreadCrumb(`${publicationNormalized?.title}`)}>
            <PublicationDetailRefactored
                brand
                type="myPublication"
                logoDealerships={publicationAux?.data?.branch_data?.picture}
                publication={publicationNormalized}
                loading={publication?.fetching === "loading" || publication?.articles?.fetching === "loading"}
                vehicleTypeSelected="new"
                selectedDealership={selectedDealership}
                setSelectedDealership={setSelectedDealership}
                selectedVersion={selectedVersion}
                setSelectedVersion={setSelectedVersion}
            >
                {
                    <>
                        <ButtonShared
                            onPress={handlePressManagement}
                            title="Gestión"
                            tertiary
                            className={styles.management}
                            id="managementPublicationButton"
                            size={"small"}
                        />
                        <ButtonShared
                            onPress={handlePressEdit}
                            title="Editar"
                            primary
                            disabled={publication?.data?.paused || !["published", "rejected"].includes(publication?.data?.status_brief?.code)}
                            className={styles.edit}
                            size={"small"}
                        />
                    </>
                }
            </PublicationDetailRefactored>
        </ProfileCard>
    )
}

export default Detail;